import LinkButton from "components/LinkButton";
import TextTranslator from "components/TranslateText/TextTranslator";
import { formatCurrency } from "helpers/formatCurrency";
import React from "react";
import { calculateDonationTotal } from "widgets/Donation/utils/donationCalculatorHelpers";
import { getCaseFormattedFrequencyLabel } from "widgets/Donation/utils/regularGivingHelpers";
import { getPayButtonLabel, handleStripeSubmit } from "./utils";

export default function StripePaymentElement(
  data,
  index,
  formProps,
  handlers,
  donationFormContext,
) {
  const {
    recipient: {
      camp_status,
    },
    feeStructure,
  } = data;

  const {
    donation: {
      isSubmitting,
      isError,
      errorMessage,
    },
    isBlocked,
    isIntentRefreshing,
  } = donationFormContext;

  const {
    values: { selectedPaymentMethodType },
    setFieldValue,
  } = formProps;

  if (isBlocked) {
    return null;
  }

  const regularGivingContext = {
    values: formProps.values,
    perk: formProps.values.perksCart,
    regularGiving: data.regularGiving,
  };

  const donationTotal = calculateDonationTotal(feeStructure, formProps);
  const submitPayment = () => handleStripeSubmit(handlers);
  const submitButtonValue = selectedPaymentMethodType === "paypal" ? "paypal" : "paymentElement";

  return (
    <>
      <LinkButton
        id="js-donate-action-stripe"
        isBold
        isDisabled={
          camp_status === "draft"
          || donationTotal <= 0
          || isIntentRefreshing
        }
        isFullWidth
        isLoading={isSubmitting}
        loadingMessage={<TextTranslator>Submitting payment...</TextTranslator>}
        look={selectedPaymentMethodType === "paypal" ? "paypal" : "primary"}
        type="submit"
        onClick={() => {
          // in case a user has first tried to click wallet payment, we must reset the submitButton value
          setFieldValue("submitButton", submitButtonValue);
          submitPayment();
        }}
        size="large"
        className="mt-1"
      >
        <TextTranslator replacements={
          {
            currency: formatCurrency(donationTotal, feeStructure),
          }
        }
        >
          Pay :currency
        </TextTranslator>
        <span>
          {getCaseFormattedFrequencyLabel(regularGivingContext)}
          {" "}
          {getPayButtonLabel(selectedPaymentMethodType)}
        </span>
      </LinkButton>

      {
          (isError)
            && (
              <div className="donation-form__error">
                { errorMessage }
              </div>
            )
        }
    </>
  );
}
